import { APP_LOCALES, type TargetAppLocale } from '@govinity/shared-config/locales';

// In the caption language rather than the page's: the viewer chose to read captions in it.
const NOTICES: Record<TargetAppLocale, string> = {
  'es-us': 'Estos subtítulos se traducen con IA y pueden contener errores.',
  zh: '这些字幕由人工智能翻译，可能存在错误。',
  'zh-hant': '這些字幕由人工智慧翻譯，可能有錯誤。',
  vi: 'Phụ đề này được dịch bằng AI và có thể có lỗi.',
  tl: 'Isinalin ng AI ang mga caption na ito at maaaring may mga mali.',
  ar: 'تمت ترجمة هذه الترجمة النصية بواسطة الذكاء الاصطناعي وقد تحتوي على أخطاء.',
  fr: 'Ces sous-titres sont traduits par IA et peuvent contenir des erreurs.',
  ko: '이 자막은 AI로 번역되었으며 오류가 있을 수 있습니다.',
  ru: 'Эти субтитры переведены с помощью ИИ и могут содержать ошибки.',
  pt: 'Estas legendas são traduzidas por IA e podem conter erros.',
  de: 'Diese Untertitel wurden mit KI übersetzt und können Fehler enthalten.',
  it: "Questi sottotitoli sono tradotti con l'IA e possono contenere errori.",
};

/**
 * The machine-translation disclosure for a caption track's language (its HLS `LANGUAGE`, e.g. `es-US`), or null
 * for English and anything we don't translate into.
 */
export const getMachineTranslationNotice = (
  captionLanguage: string
): { language: string; text: string } | null => {
  const locale = (Object.keys(APP_LOCALES) as TargetAppLocale[]).find(
    (key) => APP_LOCALES[key].captionLanguage.toLowerCase() === captionLanguage.toLowerCase()
  );
  return locale === undefined
    ? null
    : { language: APP_LOCALES[locale].captionLanguage, text: NOTICES[locale] };
};
